import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';
import { Account } from '../../shared/account.model';
import { AccountService } from '../../shared/account.service';
import { Category } from '../../../category/shared/category.model';

@Component({
  selector: 'app-account-dashboard-charts',
  templateUrl: './account-dashboard-charts.component.html',
  styleUrls: ['./account-dashboard-charts.component.scss']
})
export class AccountDashboardChartsComponent implements OnInit {

  @Input() month?: string;
  @Input() accounts?: Account[];
  @Output() legendClicked = new EventEmitter<string[]>();

  categories?: Category[];
  displayedLabels: string[] = [];

  constructor(private _accountService: AccountService) { }

  async ngOnInit() {
    this.categories = (await this._accountService.retrieveAllCategories().toPromise()).entities;
  }

  onLegendClicked(displayedLabels: string[]) {
    this.displayedLabels = displayedLabels;
    this.legendClicked.emit(displayedLabels);
  }
}
